$(function () {
    $('.tour-gallery[data-tour-gallery-images]').each((i, element) => {
        const $gallery = $(element);
        const images = JSON.parse($gallery.attr('data-tour-gallery-images'));
        if (!images.length) return;

        if (document.documentElement.lang.split('-')[0] === 'en') {
            const mobile = window.matchMedia('(max-width: 767.98px)');
            const $button = $gallery.children('.gallery-button');
            const desktopText = $button.text();
            function updateButtonText() {
                $button.text(mobile.matches ? 'Gallery (' + images.length + ')' : desktopText);
            }
            updateButtonText();
            if (mobile.addEventListener) mobile.addEventListener('change', updateButtonText);
            else mobile.addListener(updateButtonText);
        }

        $gallery.on('click', '[data-tour-gallery-index]', function (e) {
            e.preventDefault();
            const index = Number($(this).attr('data-tour-gallery-index')) || 0;
            const instance = $gallery.data('lightGallery');
            if (instance) {
                instance.index = index;
                instance.build(index);
            } else {
                $gallery.lightGallery({
                    dynamic: true,
                    dynamicEl: images,
                    index: index,
                    thumbnail: true,
                    download: false,
                    fullScreen: true,
                    preload: 2
                });
            }
        });
    });
});
